import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=e45e18fa&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e45e18fa')) {
      api.createRecord('e45e18fa', component.options)
    } else {
      api.reload('e45e18fa', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=e45e18fa&", function () {
      api.rerender('e45e18fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4ZzvH23a4DZkG/JS/pricehelp.vue"
export default component.exports